import { sanitizeSiteTitle } from '@common/utils/strings/sanitizeSiteTitle'
import { Helmet, HelmetProvider } from '@dr.pogodin/react-helmet'
import { useLogger } from '@omnia/ui/src/lib/hooks/useLogger'
import { occUiVersion } from '@vista-digital/occ-ui/src/version'
import type { FunctionComponent } from 'react'
import { useMemo } from 'react'
import { CmsLinkComponent } from './cms/components/cmsLink/CmsLink'
import { OmniaComponentsContext } from './common/contexts/omniaComponentsContext'
import { SignInModal } from './content/components/membership/signInModal/SignInModal'
import OccContext from './content/components/occConfiguration/OccContextComponent'
import { CinemaService } from './content/services/cinema.service'
import { cmsDataService } from './content/services/cms.data.service'
import { OmniaServiceContext } from './content/services/omnia-service-context'
import { UrlService } from './content/services/url.service'
import { PromoTiles } from './features/browsing/components/promoTiles/PromoTiles'
import { PagesRouter } from './routing/PagesRouter'

interface AppOverrideProps {
    pagesRouterOverride?: FunctionComponent
}

export const App: FunctionComponent<AppOverrideProps> = props => {
    const logger = useLogger('App')

    logger.info('App rendering', {
        loadTime: Date.now() - window.loadMs,
        version: APP_VERSION,
        buildTime: new Date(APP_BUILD_TIME).toString(),
        occVersion: occUiVersion,
        connectVersion: cmsDataService.get()?.connectVersion,
        isStoryBook: IS_STORYBOOK,
    })

    const PagesRouterElement = useMemo(() => props.pagesRouterOverride ?? PagesRouter, [props.pagesRouterOverride])

    return (
        <HelmetProvider>
            <OmniaComponentsContext.Provider
                value={{ CmsLink: CmsLinkComponent, SignInModal: SignInModal, PromoTiles: PromoTiles }}
            >
                <OmniaServiceContext.Provider
                    value={{ cinemaService: new CinemaService(), urlService: new UrlService() }}
                >
                    <OccContext>
                        <Helmet>
                            <title>{sanitizeSiteTitle(cmsDataService.get().siteTitle)}</title>
                        </Helmet>
                        <PagesRouterElement />
                    </OccContext>
                </OmniaServiceContext.Provider>
            </OmniaComponentsContext.Provider>
        </HelmetProvider>
    )
}
